<template>
  <div class="community column">
    <div v-if="!modal.show">
      <div class="divider"></div>
      <iframe
        height="315"
        frameborder="0"
        allowfullscreen
        src="https://www.youtube.com/embed/dKlBLX0LHxQ"
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
      ></iframe>
      <br />
      <br />
      <a class="row justify-center" @click="checkDiscourse()" target="_blank">
        <button class="button button-green-dark">CONTINUAR PARA O PRODUTO</button>
      </a>
    </div>
    <div v-if="modal.show" class="discourse">
      <div class="content">
        <div class="column align-center title">
          <img src="../../assets/img/ico_ns_community.svg" width="100" />
          <div class="text">
            Seja bem-vindo à
            <b>NS Community</b>
          </div>
        </div>
        <br />
        <br />
        <p>Criamos um novo fórum de discussão da NetSupport - NS Community.</p>
        <p>
          A NS Community é um espaço onde você pode se conectar com outros Supporters e pessoas ligadas a tecnologia para tirar dúvidas, participar de discussões,
          compartilhar ideias e sugestões e se manter informado sobre o mercado de TI.
        </p>
        <p>Para acessar nosso fórum, será necessário escolher um nome de usuáiro.</p>

        <div>
          <br />
          <br />
          <b>Escolha seu nome de usuário na NS Community</b>
          <br />
          <input type="text" class="input" placeholder="Nome de usuário" v-model="discourse" />
          <br />
          <br />
          <br />
          <div class="row justify-center">
            <Button
              layout="green-go"
              :disabled="discourse.length>2 ? false : true"
              @click="REGISTER(discourse).then(r=>modal.show=false)"
            >Registrar</Button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Button from "@/components/Button.vue";

export default {
  name: "Community",
  components: {
    Button
  },
  data() {
    return {
      discourse: "",
      modal: {
        show: false
      }
    };
  },
  methods: {
    ...mapActions("user", ["REGISTER"]),
    checkDiscourse() {
      if (this.user.usuario_discourse.length == 0 || this.user.usuario_discourse==null || this.user.usuario_discourse=='null') {
        this.modal.show = true;
      } else {
        window.location = this.user.ns_community;
      }
    }
  },
  computed: {
    ...mapGetters("user", ["user"])
  }
};
</script>

<style lang="scss" scoped>
@use "@/assets/scss/vars.scss" as *;
.community {
  padding-top: 25px;
  color: $gray-6;
  padding: 10px 30px;
  padding-top: 25px;
  padding-bottom: 25px;
  @media (min-width: $small) {
    /* width: 50%; */
    width: 600px;
  }
  iframe {
    width: 100%;
    min-height: 100%;
  }
  .discourse {
    .content {
      text-align: justify;
      padding: 25px;
      font-size: 0.9rem;
      .title {
        .text {
          font-size: 1.2rem;
          color: $green-1;
          margin-left: 20px;
          margin-top: 20px;
        }
      }
    }
  }
}
</style>